module.exports = __webpack_public_path__ + "img/googlereviewsp2.756800f6.png";